var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.175 58.0352L108.263 74.4438L91.8561 59.5306",
    stroke: "white",
    strokeWidth: 5.13239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0062 37.8325C50.5637 20.7128 77.0465 19.4468 94.1662 35.0043C103.302 43.3067 107.925 54.7215 107.883 66.164C107.873 68.4386 107.68 70.7167 107.301 72.9689",
    stroke: "white",
    strokeWidth: 5.13239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.833 73.9651L23.7444 57.5564L40.1514 72.4696",
    stroke: "white",
    strokeWidth: 5.13239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9982 94.1678C81.4406 111.287 54.9578 112.553 37.8381 96.9959C28.7021 88.6936 24.0807 77.277 24.1215 65.8363C24.133 63.5598 24.3241 61.2835 24.703 59.0314",
    stroke: "white",
    strokeWidth: 5.13239,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.4196,
    height: 94.8166,
    fill: "white",
    transform: "translate(64.4277 0.476074) rotate(42.263)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.b6a1e1ceffc9ec7a7a61e20549433a42.svg";
export { ForwardRef as ReactComponent };